import { BaseRecord } from "./BaseRecord";
import { State } from "./State";

export class City extends BaseRecord<number> {
    public name: string;
    public stateId!: number;
    public state: State | null;

    constructor() {
        super();
        this.id = 0;
        this.name = "";
        this.stateId = 0;
        this.state = new State();
    }
}
